import { render, staticRenderFns } from "./CbsNxzRecruit.vue?vue&type=template&id=4fa7ff58&scoped=true"
import script from "./CbsNxzRecruit.vue?vue&type=script&lang=js"
export * from "./CbsNxzRecruit.vue?vue&type=script&lang=js"
import style0 from "./CbsNxzRecruit.vue?vue&type=style&index=0&id=4fa7ff58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7ff58",
  null
  
)

export default component.exports